
// Provides configuration and packages for froala and froalaView components

<script>
// Require Froala Editor js/css files.
require("froala-editor/js/plugins.pkgd.min");
require("froala-editor/js/froala_editor.pkgd.min");
require("froala-editor/css/froala_editor.pkgd.min.css");
require("font-awesome/css/font-awesome.css");
require("froala-editor/css/froala_style.min.css");
import { mapMutations } from "vuex";

import VueFroala from "vue-froala-wysiwyg";

import customPlugin from '../custom_module/plugins/js/froala-bootstrap-grid.plugin'

require ('../custom_module/plugins/css/froala-bootstrap-grid.plugin.css')
import api from "../api";
import * as CONSTANTS from '../store/constants'
export default  {
    computed: {
        config() {
            var defaultConfig = {
                heightMax: 150,
                toolbarSticky:false,
                htmlUntouched: true,
                placeholderText: "",
                immediateVueModelUpdate: true,
                key: CONSTANTS.FROALA_KEY,
                height: "150px",
                width: "100%",
                charCounterCount: false,
                overflow: "scroll",
                contenteditable: false,
                attribution: false,
                quickInsertTags: [""],
                imageUploadURL: false,
                imageUploadRemoteUrls: false,
                events: {
                    "link.beforeInsert": function(link, text, attrs) {
                        if (attrs && text) {
                            attrs.title = text;
                        }
                    },
                    // Copy and pasting links in the same article includes inline styles with more weight.
                    // Which causing an issue to apply css changes to that content. Example: Missing the links hover css changes.
                    // So, in this method cleaning content for hyperlinks ( Removing style weights ) before pasting it.
                    "paste.beforeCleanup": function (clipboard_html) {
                        if(clipboard_html.includes('<a')){
                            var removeStyleWeight = '!important';
                            if(clipboard_html && clipboard_html.includes(removeStyleWeight)){
                                return clipboard_html.replaceAll(removeStyleWeight, '');
                            }
                        }
                        return clipboard_html;
                    }
                },
                imageAllowedTypes: [
                    "jpeg","jpg","png","gif","webp",
                    "jpeg;base64",
                    "jpg;base64",
                    "png;base64",
                    "gif;base64",
                    "webp;base64"
                ],
                toolbarButtons: [
                  "fullscreen",
                  "bold",
                  "italic",
                  "underline",
                  "strikeThrough",
                  "subscript",
                  "superscript",
                  "fontSize",
                  "textColor",
                  "backgroundColor",
                  "inlineStyle",
                  "clearFormatting",
                  "paragraphFormat",
                  "align",
                  "formatOL",
                  "formatUL",
                  "outdent",
                  "indent",
                  "quote",
                  "-",
                  "insertLink",
                  "customLink",
                  "insertImage",
                  "insertVideo",
                  "insertFile",
                  "insertTable",
                  "horizontalBlocks",
                  "specialCharacters",
                  "insertHR",
                  "selectAll",
                  "print",
                  "spellChecker",
                  "help",
                  "html",
                  "undo",
                  "redo"
                ],
                paragraphFormat: {
                    N: 'Normal',
                    H1: 'Heading 1',
                    H2: 'Heading 2',
                    H3: 'Heading 3'
                }
            };
            return Object.assign(defaultConfig, this.extraConfig);
        }
    },
    data() {
        return {
            isEditorReady: false,
            extraConfig: {},
            isReadMode: false
        };
    },
    methods: {

        ...mapMutations(["setIsLoading"]),
        getImageHash() {
            this.setIsLoading(true);
            api
                .getImageSignature()
                .then(response => {
                    this.config.imageUploadToS3 = response.data;
                })
                .catch(e => {
                    console.error(e);
                })
                .finally(() => {
                    this.isEditorReady = true;
                    this.setIsLoading(false);
                });
        }
    },
    mounted() {
        if (!this.isReadMode) {
            this.getImageHash();
        }
    }
};
</script>

<style>
.fr-view p {
  overflow: visible;
  white-space: normal;
  font-size: 16px;
  color: #000000 !important;
}
.fr-view ul {
  list-style-position: outside !important;
  list-style-type: disc !important;
}
.fr-view ul ul {
  list-style-type: circle !important;
}
.fr-toolbar.fr-top {
  border-radius: 0;
}
.tableBorderTitleGray thead tr th,
.tableBorderTitleGray tbody tr td {
  border: 1px solid #000000 !important;
}
.tableBorderContentGray thead tr th,
.tableBorderContentGray tbody tr td {
  border: 1px solid #000000 !important;
}
.tableBorderDefault thead tr th,
.tableBorderDefault tbody tr td {
  border: 1px solid #ddd !important;
}
.tableBorderTitleGraySolid thead tr th,
.tableBorderTitleGraySolid tbody tr td {
  border: 2px solid #717171 !important;
}
.tableBorderContentGraySolid thead tr th,
.tableBorderContentGraySolid tbody tr td {
  border: 2px solid #666666 !important;
}
.tableBorderDefaultSolid thead tr th,
.tableBorderDefaultSolid tbody tr td {
  border: 2px solid #ddd !important;
}

/*Please don't remove below .fr-view .froala* styles. These needed for WWFO KB support*/
.fr-view .froalaNormal {
  font-size: 11pt !important;
  font-family: artifaktElementRegular !important;
}
.fr-file-view-close{
  top: 100px !important;
}
.fr-view .froalaHeader1,
.fr-view h1 * {
  font-size: 26px !important;
  line-height: 1.5 !important;
  color: #000000 !important;
  font-family: artifaktElementRegular !important;
}
.fr-view .froalaHeader2,
.fr-view h2 * {
  font-size: 20px !important;
  line-height: 1.5 !important;
  color: #000000 !important;
  font-family: artifaktElementBold !important;
}
.fr-view .froalaHeader3,
.fr-view h3 * {
  font-size: 16pt !important;
  line-height: 1.5 !important;
  color: #000000 !important;
  font-family: artifaktElementBold !important;
}

/*=================================*/

.fr-view li {
  font-size: 14px;
  color: #000000;
}

/*Froala preview data should also be consistent to 16px*/
.fr-view td,
.fr-view div,
.fr-view span,
.fr-view strong,
.fr-view b,
.fr-view i,
.fr-view a {
  font-size: 16px;
}

.fr-view .eh-force-text-white * {
  color: white !important;
}

.fr-element table td.fr-selected-cell, .fr-element table th.fr-selected-cell {
  border: 1px double var(--secondary-color);
}
</style>



// WEBPACK FOOTER //
// src/mixins/FroalaMixin.vue